// @flow

import * as React from 'react';
import { BrowserRouter, withRouter } from 'react-router-dom';

import AppRoot from './App/Root';
import AuthRoot from './Auth/Root';
import UserProvider_ from './UserProvider';
import WhiteLabelProvider from './WhiteLabelProvider';

const UserProvider = withRouter(UserProvider_);
const appChildren = ({ userState, ...rest }: *) =>
  userState === 'AUTHENTICATED' ? (
    <AppRoot key="app" {...rest} />
  ) : (
    <AuthRoot key="auth" {...rest} />
  );

// FIXME: these types are really weak
type Props = {
  Router?: Object,
  children?: Function,
};

const App = ({ Router = BrowserRouter, children = appChildren }: Props) => (
  <WhiteLabelProvider>
    <Router>
      <UserProvider>{children}</UserProvider>
    </Router>
  </WhiteLabelProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/Root.js